export default "/images/cpd.png";